<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['graphType','anno','cu', 'chartId'],
  data: () => ({
    label_fail:"",
    label_pass:"",
    chartdata: {
      labels: [],
      datasets: [
        ]
    },
    dataGroups: [],
    options: {
     legend:{
       display:false, 
       align:"end"},
     scales: {
					yAxes: [{
            stacked:true,
						ticks: {
              beginAtZero: true,
              max: 5,
              min: 0,
              stepSize: 1
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
            stacked:true,
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
     responsive: true,
     maintainAspectRatio: false,
     options: {
        // This chart will not respond to mousemove, etc
        onhover: ['click'],
    }

    }
  }),
  watch: {
    anno: function(newVal,oldVal) {
      console.log("anno cambiato da " + oldVal + " a " + this.anno);
      this.buildChart();
    },
    cu: function(newVal,oldVal) {
      console.log("centrale cambiata da " + oldVal + " a " + this.cu);
      this.buildChart();
    },
    
  },
  computed: {
    unitsDetails() {
      return this.$store.state.plantUnits;
    }, 
  },
  methods: {
    handleClick(point,event) {
      const item = event[0];
      console.log("click event on pos and item", point, item);
      this.$emit("selectedMonth", {source:this.chartId, selectedIndex: item._index, month: this.dataGroups[item._index]});
    },
    buildChart() {
      console.log("graphType=" + this.graphType+", anno:" + this.anno+",centrale:" + this.cu);
      if (this.anno == '' || this.anno.indexOf('-') <0) {
        this.buildYearChart();
      } else {
        this.buildMonthChart();
      }
    },

    buildYearChart() {

      if (this.$store.state.currentLogbooks != null) {
        var endDate = this.moment(new Date()).startOf('month').add(1, 'months');
        if (this.anno != '') {
          endDate = this.moment('' + (parseInt(this.anno) + 1) + '-01-01', 'YYYY-MM-dd').startOf('year');
        }
        console.log("end date=" + endDate.format('DD-MM-YYYY'));
        var startDate = this.moment(endDate).subtract(12, 'months');
        console.log("intervallo = " + startDate.format('DD-MM-YYYY') + " ... " + endDate.format('DD-MM-YYYY'));

        let self = this;
        //this.chartdata.datasets[0].label=this.$t("pass");
        //this.chartdata.datasets[1].label=this.$t("fail");
        //this.chartdata.datasets[2].label=this.$t("disconnected");
        //this.renderChart(this.chartdata, this.options)

        //filtra i logbook relativi esclusivamente a test funzionali e di autonomia
        var functSortedLogbook = this.$store.state.currentLogbooks.filter(function (item) {
          var data = self.moment(item.log_timestamp * 1000);
          if (data.isSameOrAfter(endDate) || data.isBefore(startDate)) return false;
          return item.log_type == self.graphType;
          //item.log_type != "assenza_rete" && item.log_type != "rientro_rete" && item.log_type !="test_autonomia_automatico" 
        });

        //ordina i logbook per data (ultimo il più recente)
        functSortedLogbook.sort(function (a, b) {
          if (a.cu_id != b.cu_id) return ('' + a.cu_id).localeCompare(b.cu_id);
          return a.log_timestamp - b.log_timestamp;
        });
        console.log("functSortedLogbook: ", functSortedLogbook);

        var functLogbookPlant = [];
        var maxY = 0;

        //set nel grafico dei dati

        var prevCu_id = "";
        var datasetIndex = -2;

        var labels = [];
        var labDate = this.moment(startDate);
        this.dataGroups = [];
        for (var i = 0; i < 12; i++) {
          labels.push(labDate.format('MMM-YYYY'));
          this.dataGroups.push(labDate.format('YYYY-MM'));
          labDate.add(1, 'months');
        }
        this.chartdata.labels = labels;
        this.chartdata.datasets = [];

        let greens = ['#00ff00', '#00bb00', '#009900', '#00ee00', '#00aa00', '#00ff33', '#00bb33', '#009933', '#00ee33', '#00aa33', '#33ff00', '#33bb00', '#339900', '#33ee00', '#33aa00', '#33ff33', '#33bb33', '#339933', '#33ee33', '#33aa33'];
        let reds = ['#ff0000', '#ee0000', '#dd0000', '#cc0000', '#bb0000', '#ff1100', '#ee1100', '#dd1100', '#cc1100', '#bb1100', '#ff2200', '#ee2200', '#dd2200', '#cc2200', '#bb2200', '#ff1111', '#ee1111', '#dd1111', '#cc1111', '#bb1111']

        for (var k = 0; k < functSortedLogbook.length; k++) {

        let lb = functSortedLogbook[k];
        let cu_id = lb.cu_id;
        let cu_type =lb.log_system;
        let cu_date =lb.log_date;
        
        //cu_desc deve essere valorizzato con la descrizione attuale della centrale e non con quanto eventulamente presente nel logbook
        //console.log("unitsDetails",this.unitsDetails);
        // let cu_desc = "";
        // cu_desc = (this.unitsDetails || []).find(item => item.cu_id == cu_id).cu_desc;
        // lb.cu_desc = cu_desc;
        let cu_desc = "";
        if (this.unitsDetails) {
          cu_desc = this.unitsDetails.find(item => item.cu_id == cu_id)?.cu_desc || "";
        } 
        lb.cu_desc = cu_desc;

        // let cu_desc="";
        // if(lb.cu_desc){
        //   cu_desc=lb.cu_desc;
        // };
        //console.log ("cu desc",cu_desc);        
        let dataLog = this.moment(lb.log_timestamp*1000);
        let dataIndex = dataLog.diff(startDate,'months');
        //console.log("log date graph" + dataLog.format('DD-MM-YYYY')+" index=" + dataIndex + " cu=" + cu_id + " esito=" + lb.log_esito);
                
        //this.chartdata.labels[k]

          if (cu_id != prevCu_id) {
            prevCu_id = cu_id;
            datasetIndex += 2;
            this.chartdata.datasets.push({
              label: cu_desc + ' - ' + cu_type + " " + cu_id + " Pass",
              barThickness: 10,
              backgroundColor: "#29CC90",
              //backgroundColor: greens[(datasetIndex/2) % 20],
              //hoverBackgroundColor:'#29CC35',
              hoverBorderWidth: 1,
              //hoverBorderColor: '#FFFFDD',
              type: 'bar',
              stack: ''+cu_id,
              data: [0,0,0,0,0,0,0,0,0,0,0,0],              
              borderColor: "#000000",       // contorno nero
              borderWidth: 1                // spessore del bordo

            });
            this.chartdata.datasets.push({
              label: cu_desc + ' - ' + cu_type + " " + cu_id + " Fail",
              barThickness: 10,
              backgroundColor: reds[(datasetIndex / 2) % 20],
              //hoverBackgroundColor:'#E10000',
              hoverBorderWidth: 1,
              //hoverBorderColor: '#FFFFDD',
              type: 'bar',
              stack: ''+cu_id,
              data: [0,0,0,0,0,0,0,0,0,0,0,0],
              borderColor: "#000000",       // contorno nero
              borderWidth: 1                // spessore del bordo

            });
          }

          if (this.cu == cu_id || this.cu == this.$t("graph.all_central")) {

            var curr_ok = this.chartdata.datasets[datasetIndex].data[dataIndex];
            var curr_fail = this.chartdata.datasets[datasetIndex + 1].data[dataIndex];

            if (lb.log_lamps.length > maxY) maxY = lb.log_lamps.length;

            if (lb.log_esito == 'pass') {
              this.chartdata.datasets[datasetIndex].data[dataIndex] = lb.log_lamps.length;
              this.chartdata.datasets[datasetIndex].label = lb.cu_desc + " (" + lb.cu_id + ") " + " \n" + " Lamp pass";
              this.chartdata.datasets[datasetIndex + 1].data[dataIndex] = 0;
            } else {
              var lamp_pass = 0;
              var lamp_fail = 0;
              for (var j = 0; j < lb.log_lamps.length; j++) {
                if (lb.log_lamps[j].error_batt_short == "OFF" && lb.log_lamps[j].error_batt_test == "OFF" && lb.log_lamps[j].error_com == "OFF" && lb.log_lamps[j].error_hardware == "OFF" && lb.log_lamps[j].error_led == "OFF")
                  lamp_pass++;
                else
                  lamp_fail++;
              }
              this.chartdata.datasets[datasetIndex].data[dataIndex] = lamp_pass;
              this.chartdata.datasets[datasetIndex].label = lb.cu_desc + " (" + lb.cu_id + ") " + " \n" + " Lamp pass";
              this.chartdata.datasets[datasetIndex + 1].data[dataIndex] = lamp_fail;
              this.chartdata.datasets[datasetIndex + 1].label = lb.cu_desc + " (" + lb.cu_id + ") " + " \n" + " Lamp fail";
            }

          }
        }

        this.options.scales.yAxes[0].ticks.max = maxY + 1;
        this.options.onClick = this.handleClick;
        this.renderChart(this.chartdata, this.options)

        //console.log("functPlantLogbook: ", functLogbookPlant);
        console.log("chartData:",this.chartdata, " options:", this.options);


      }
    },

    buildMonthChart() {

      var endDate = this.moment(new Date()).startOf('month').add(1,'months');
      if (this.anno != '') {
        endDate = this.moment(''+this.anno+'-01','YYYY-MM-dd').add(1,'months');
      }
      console.log("end date=" + endDate.format('DD-MM-YYYY'));
      var startDate = this.moment(endDate).subtract(1,'months');
      console.log("intervallo = " + startDate.format('DD-MM-YYYY') + " ... " + endDate.format('DD-MM-YYYY'));

      let self = this;
      //this.chartdata.datasets[0].label=this.$t("pass");
      //this.chartdata.datasets[1].label=this.$t("fail");
      //this.chartdata.datasets[2].label=this.$t("disconnected");
      //this.renderChart(this.chartdata, this.options)
 
      //filtra i logbook relativi esclusivamente a test funzionali e di autonomia
      var functSortedLogbook = this.$store.state.currentLogbooks.filter(function(item) {
        var data = self.moment(item.log_timestamp*1000);
        if (data.isSameOrAfter(endDate) || data.isBefore(startDate)) return false;
        return item.log_type == self.graphType;
          //item.log_type != "assenza_rete" && item.log_type != "rientro_rete" && item.log_type !="test_autonomia_automatico" 
      });
    
    //ordina i logbook per data (ultimo il più recente)
      functSortedLogbook.sort(function(a, b) {
        if (a.cu_id != b.cu_id) return (''+a.cu_id).localeCompare(b.cu_id);
        return a.log_timestamp - b.log_timestamp;
      });
      console.log("functSortedLogbook: ", functSortedLogbook);
    
    var functLogbookPlant=[];
    var maxY=0;

    //set nel grafico dei dati

    var prevCu_id = "";
    var datasetIndex = -2;

    var labels = [];
    var labDate = this.moment(startDate).locale('it');
    this.dataGroups = [];
    var daysInMonth = this.moment(this.anno,'YYYY-MM').daysInMonth();
    for (var i=0; i<daysInMonth; i++) {
      labels.push(labDate.format('ddd D'));
      labDate.add(1,'days');
    }
    this.chartdata.labels = labels;
    this.chartdata.datasets = [];

    let greens = ['#00ff00','#00bb00','#009900','#00ee00','#00aa00','#00ff33','#00bb33','#009933','#00ee33','#00aa33','#33ff00','#33bb00','#339900','#33ee00','#33aa00','#33ff33','#33bb33','#339933','#33ee33','#33aa33'];
    let reds =    ['#ff0000','#ee0000','#dd0000','#cc0000','#bb0000','#ff1100','#ee1100','#dd1100','#cc1100','#bb1100','#ff2200','#ee2200','#dd2200','#cc2200','#bb2200','#ff1111','#ee1111','#dd1111','#cc1111','#bb1111']

    for (var k=0; k<functSortedLogbook.length; k++) {

        let lb = functSortedLogbook[k];
        let cu_id = lb.cu_id;
        let cu_type =lb.log_system;
        let cu_date =lb.log_date;
        //cu_desc deve essere valorizzato con la descrizione attuale della centrale e non con quanto eventulamente presente nel logbook
        let cu_desc = (this.unitsDetails || []).find(item => item.cu_id == cu_id).cu_desc;
        lb.cu_desc = cu_desc;
        // let cu_desc="";
        // if(lb.cu_desc){
        //   cu_desc=lb.cu_desc;
        // };

        //console.log ("cu desc",cu_desc);        
        let dataLog = this.moment(lb.log_timestamp*1000);
        let dataIndex = dataLog.diff(startDate,'days');
        //console.log("log date graph" + dataLog.format('DD-MM-YYYY')+" index=" + dataIndex + " cu=" + cu_id + " esito=" + lb.log_esito);
                
        //this.chartdata.labels[k]

        if (cu_id != prevCu_id) {
            prevCu_id = cu_id;
            datasetIndex +=2;  
            this.chartdata.datasets.push({
              label: cu_desc + ' - ' + cu_type + " "  + cu_id+" Pass",
              barThickness: 10,
              backgroundColor: "#29CC90",
              //backgroundColor: greens[(datasetIndex/2) % 20],
              //hoverBackgroundColor:'#29CC35',
              hoverBorderWidth: 1,
              //hoverBorderColor: '#FFFFDD',
              type: 'bar',
              stack: ''+cu_id,
              data: new Array(daysInMonth).fill(0),
              borderColor: "#000000",       // contorno nero
              borderWidth: 1                // spessore del bordo
            });
            this.chartdata.datasets.push({
              label: cu_desc + ' - ' + cu_type  + " " + cu_id+" Fail",
              barThickness: 10,
              backgroundColor: reds[(datasetIndex/2) % 20],
              //hoverBackgroundColor:'#E10000',
              hoverBorderWidth: 1,
              //hoverBorderColor: '#FFFFDD',
              type: 'bar',
              stack: ''+cu_id,
              data: new Array(daysInMonth).fill(0),
              borderColor: "#000000",       // contorno nero
              borderWidth: 1                // spessore del bordo
            });
        }
        
        if (this.cu==cu_id || this.cu==this.$t("graph.all_central"))
        {
        
        var curr_ok = this.chartdata.datasets[datasetIndex].data[dataIndex];
        var curr_fail = this.chartdata.datasets[datasetIndex+1].data[dataIndex];

        if (lb.log_lamps.length > maxY) maxY = lb.log_lamps.length;

        if (lb.log_esito == 'pass') {
          this.chartdata.datasets[datasetIndex].data[dataIndex] = lb.log_lamps.length;
          this.chartdata.datasets[datasetIndex].label=  lb.cu_desc + " (" + lb.cu_id +") " + " \n" +" Lamp pass";
          this.chartdata.datasets[datasetIndex+1].data[dataIndex] = 0;
        } else {
          var lamp_pass=0;
          var lamp_fail=0;
           for (var j=0; j<lb.log_lamps.length; j++)
           {
             if (lb.log_lamps[j].error_batt_short=="OFF" && lb.log_lamps[j].error_batt_test=="OFF" && lb.log_lamps[j].error_com=="OFF" && lb.log_lamps[j].error_hardware=="OFF" && lb.log_lamps[j].error_led=="OFF")
              lamp_pass++; 
             else
              lamp_fail++; 
           } 
             this.chartdata.datasets[datasetIndex].data[dataIndex] = lamp_pass;
             this.chartdata.datasets[datasetIndex].label=  lb.cu_desc + " (" + lb.cu_id +") " + " \n" +" Lamp pass";
             this.chartdata.datasets[datasetIndex+1].data[dataIndex] = lamp_fail;
             this.chartdata.datasets[datasetIndex+1].label=  lb.cu_desc + " (" + lb.cu_id +") " + " \n" +" Lamp fail";           
        }

        }
    }

      this.options.scales.yAxes[0].ticks.max=maxY+1;     
      //this.options.onClick = this.handleClick; 
      this.renderChart(this.chartdata, this.options)

      //console.log("functPlantLogbook: ", functLogbookPlant);
      console.log("chartData:",this.chartdata);


    }

  },
  mounted () {
    console.log("chart mounted");
    window.setTimeout(this.buildChart,100); 
  }

}
</script>